﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute,NavigationEnd } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants} from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import { MatDialog, MatTable } from '@angular/material';

import { MatIconModule } from '@angular/material/icon'

import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import * as moment from 'moment-timezone';
import {Location} from '@angular/common';

export interface Element {
  //'Sno': number;
  'Record ID': string;
  'Action Performed': string;
  'Action Date': string;
  
  'Action By': string;
 // 'Remarks': string;
 
}
const ELEMENT_DATA: Element[] = [
  //   { 'Sno': "", 'Record ID': '',  'Action Performed': '' , 'Action Date':'', 'Action By':''},
     ];
   



@Component({
  selector: 'app-tata-auditlog',
  templateUrl: './tata-auditlog.component.html',  
  styleUrls: ['./tata-auditlog.component.css']
})
export class TataAuditLogComponent implements OnInit {     

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  entityRefNo: any;
  response: any;
  reqStatus: any
  EntityStatus: any;
  disableForm: boolean;
  showRejectReason: boolean = false;
  showRemarks: boolean = false;
  showModifyReason: boolean = false;
  poi_type: any;
  poa_type: any;
  poafilename: any;
  poifilename: any;
  approveFlag: boolean = false
  dataSource: any;
  TataEmpRoles:any;
  allowedRoles:any;
  // rejectFlag: boolean = false
  // modifyFlag: boolean = false  

  
  private previousUrl: string;
  private currentUrl: string;

  constructor(private fb: FormBuilder,
    //private es: APILoginService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private _location: Location,
    private router: Router) {
      
  
  }//end of constructor

  displayedColumns: string[] = [ 'srno','Record ID', 'Action Date','User Role', 'Action Performed','Action By' ]; 
  //displayedColumns: string[] = [ 'Record ID', 'Action Performed','Action Date', 'Action By','Remarks'];
 
 // dataSource = new MatTableDataSource(ELEMENT_DATA);
 

  dataSubject = new BehaviorSubject<any[]>([]);

  entityForm: FormGroup;
  selectedValue: String;
  name: string;
  position: number;
  weight: number;
  symbol: string;
  modiflist: any;
  rejectlist: any;
  header_id: any;
  entityId:any;
   roleIDs:any={ 
    $or:[]
  }

  get f() { return this.entityForm.controls; }


  ngOnInit() {

    this.entityForm = this.fb.group({
      request_type: [''],
      urn_no: [''],
      creation_timestamp: ['',],
      assigned_timestamp: ['',],
      paymen_applicable: ['',],

    //  remarks: ['', [Validators.required, Validators.maxLength(200), Validators.minLength(10)]],
      rej_reason: ['',],
      modification_reason: ['',],
      header_id: [''], 

    });//end of entityForm  


    this.getEntityDetails();
console.log("this.ELEMENT_DATA[i]",ELEMENT_DATA)

  } // oninit
     
  backClicked() {  
   this._location.back();   
  }

  fetchResp(role){
    var rolekeyvalue = {
      '4': 'Finance Admin',
      '100': 'Network Admin',
      '201': 'Preference Process Owner',
      '202': 'Entity Process Owner',
      '203': 'Header Process Owner',
      '204': 'Content Template Process Owner',
      '205': 'Consent Template Process Owner',
      '206': 'Complaints Process Owner',
      '207': 'Scrubbing SMS Process Owner',
      '208': 'Scrubbing Voice Process Owner',
      '209': 'Delivery SMS Process Owner',
      '210': 'Delivery voice Process Owner',
      '302': 'Entity Registrar',
      '303': 'Header Registrar',
      '304': 'Content Template Registrar',
      '305': 'Consent Template Registrar',
      '306': 'Complaints Registrar',
      '307': 'Scrubbing SMS Registrar',
      '308': 'Scrubbing Voice Registrar',
      '309': 'Delivery SMS Registrar',
      '310': 'Delivery Voice Registrar',
      '501': 'TTL Agent',
      '601': 'Preference Manager',
      '311': 'Complaints Supervisor',

  
  }
    
    
if(this.allowedRoles.indexOf(role) === -1){
return
}
else return rolekeyvalue[role]
  }
  getSubstring(filename) {
    return filename.substring(filename.indexOf('.') + 1)
  }

  getEntityDetails() { 
    this._route.params.subscribe((params) => {  
      this.entityRefNo = params['urn'];

      console.log("THis line called")

    })
    this.TataEmpRoles=  this.db.get(Constants.SESSSION_STORAGE, Constants.TATAEMPROLES); 
    this.allowedRoles=[];  //Roles which can logged in person can approve
    console.log("this.TataEmpRoles",this.TataEmpRoles.split(','))
    var appRoles=this.TataEmpRoles.split(',')
    for(var i=0;i<appRoles.length;i++){
      if(appRoles[i]=='100'){
        this.allowedRoles.push("201","202","203","204","205","206","207","208","209","501","601","301","302","303","304","305","306","307","308","309","310","311")
      }
      else if(appRoles[i]=='201'){
        this.allowedRoles.push("501","601")
      }
      else if(appRoles[i]=='206'){
        this.allowedRoles.push("306","311")
      }
       else{
        this.allowedRoles.push(appRoles[i].replace("2", "3"))
      }
      console.log("this.allowedRoles",this.allowedRoles)

    }
    
  

    var data={
      RecordID:this.entityRefNo,
      Role    : "Tata Employee",  
      RoleID: {$elemMatch:{$in:this.allowedRoles}}
    }    
    this.es.getAuditLog(data).subscribe({

        next: value => { 
     
          this.dataSubject.next(value);
          this.dataSource = new MatTableDataSource();
    
          this.dataSource = new MatTableDataSource(value);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        // this.response = r; 
        // console.log("Response",this.response)
      // for(var i=0;i<r.length;i++){
      //   ELEMENT_DATA.push({ 'Sno': i+1,'Record ID' : r[i].RecordID, 'Action Performed':r[i].ActionPerformed  , 'Action Date':r[i].ActionDt , 'Action By':r[i].ActionBy,'Remarks':r[i].Remarks})
      // }
        }
      })
  }
  
 }  